import type {
  PlanRevisionContentSource,
  PlanRevisionEnvelopeSource,
  PlanRevisionTelemetryEnvelope,
} from "./types";

import { sanitizeTelemetry } from "./sanitizers/telemetry";
import { isRecord } from "./sanitizers/utils";

export function buildPlanRevisionTelemetryEnvelope(
  revision: PlanRevisionEnvelopeSource,
  content: PlanRevisionContentSource,
): PlanRevisionTelemetryEnvelope {
  const telemetry = sanitizeTelemetry(content.telemetry);
  return { id: revision.id, issue_key: revision.issueKey, telemetry };
}

export function sanitizePlanRevisionTelemetryEnvelope(
  value: unknown,
): PlanRevisionTelemetryEnvelope {
  if (!isRecord(value)) {
    throw new Error("Invalid telemetry envelope payload.");
  }
  const record = value;
  if (typeof record.id !== "string" || typeof record.issue_key !== "string") {
    throw new Error("Invalid telemetry envelope payload.");
  }
  const telemetry = sanitizeTelemetry(record.telemetry);
  return { id: record.id, issue_key: record.issue_key, telemetry };
}
